module.exports = __webpack_public_path__ + "static/img/IMG_20160308_130725.647b2d58.jpg";